import React from 'react';
import { DjayIllustrationProps } from '../types';
import { DjayIllustrationBase } from '../DjayIllustrationBase';
import { DjaySpecimen } from '../../DjaySpecimen';
export function ThreeSubjectsIllustration({
  achievementId,
  variant = 'frost',
  // Unlocks frost variant
  isUnlocked,
  rarity,
  size = 'md',
  animate = true,
  className = ''
}: DjayIllustrationProps) {
  return <DjayIllustrationBase isUnlocked={isUnlocked} rarity={rarity} size={size} className={className} data-id="element-4265" data-mp="2l01ia3d25qcm">
      
      <div className="relative w-full h-full bg-gradient-to-b from-sky-200 to-blue-400 overflow-hidden" data-id="element-4266" data-mp="2g9300y8iei6q">
        {/* Background: 3 Pillars */}
        <svg className="absolute inset-0 w-full h-full z-0" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4267" data-mp="2bb1e85jp84rk">
          
          {/* Left Pillar */}
          <rect x="20" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-4268" data-mp="228s77pnn2tix" />
          <rect x="25" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-4269" data-mp="1xb0h916k1hhd" />
          <polygon points="20,80 50,80 35,60" fill="#7DD3FC" data-id="element-4270" data-mp="1xctnifd99zou" />

          {/* Right Pillar */}
          <rect x="150" y="80" width="30" height="120" fill="#BAE6FD" data-id="element-4271" data-mp="1ozeu2uz8wuee" />
          <rect x="155" y="80" width="10" height="120" fill="#E0F2FE" data-id="element-4272" data-mp="1tt1amy8j5ifh" />
          <polygon points="150,80 180,80 165,60" fill="#7DD3FC" data-id="element-4273" data-mp="1g1cw6oat6hvc" />

          {/* Center Pillar (Behind Djay) */}
          <rect x="80" y="120" width="40" height="80" fill="#7DD3FC" data-id="element-4274" data-mp="1l0zbr4e40a7b" />
          <rect x="85" y="120" width="15" height="80" fill="#BAE6FD" data-id="element-4275" data-mp="28przweohpdrd" />
          <polygon points="80,120 120,120 100,100" fill="#38BDF8" data-id="element-4276" data-mp="28ne4g4pwdzja" />
        </svg>

        {/* Djay */}
        <div className="absolute inset-0 z-10 flex items-end justify-center pb-[10%]" data-id="element-4277" data-mp="2coznk7t0za1x">
          <div className="w-[65%] h-[65%] flex items-center justify-center" data-id="element-4278" data-mp="1yr2tpj5yhhqy">
            <DjaySpecimen look={{
            variant,
            accessory: 'tripleStars'
          }} size="hero" emotion={isUnlocked ? 'celebrating' : 'pointing'} animate={animate && isUnlocked} className="w-full h-full" data-id="element-4279" data-mp="23p47ppoiyqvk" />
            
          </div>
        </div>

        {/* Foreground: Frost/Magic effects */}
        {isUnlocked && <svg className="absolute inset-0 w-full h-full z-20 pointer-events-none" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-4280" data-mp="8b8pdpjn7ane">
          
            <circle cx="35" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-4281" data-mp="3vkx66m02d341" />
          
            <circle cx="165" cy="50" r="8" fill="#FDE047" opacity="0.8" filter="blur(2px)" data-id="element-4282" data-mp="3qmc2gclls1au" />
          
            <circle cx="100" cy="90" r="10" fill="#FDE047" opacity="0.6" filter="blur(3px)" data-id="element-4283" data-mp="3lplphy53hltn" />
          

            <path d="M35 40 L35 60 M25 50 L45 50" stroke="white" strokeWidth="2" data-id="element-4284" data-mp="3gnmlqn5g0mw6" />
          
            <path d="M165 40 L165 60 M155 50 L175 50" stroke="white" strokeWidth="2" data-id="element-4285" data-mp="3cnvy2sb7qmvv" />
          
          </svg>}
      </div>
    </DjayIllustrationBase>;
}